import styles from "./Button.css";
import classNames from "classnames";
import PropTypes from "prop-types";

const LoyaltyMembersDayBannerButton = ({ copy }) => (
  <a
    className={classNames("london2-button", styles.button, styles.joinButton)}
    href="https://www.asos.com/discover/our-apps/?campaign=membersDay-plpBanner"
  >
    {copy}
  </a>
);

LoyaltyMembersDayBannerButton.propTypes = {
  copy: PropTypes.string.isRequired
};

export default LoyaltyMembersDayBannerButton;
